class CartReservationTimer extends HTMLElement {
  connectedCallback() {
    const key = 'koremi-cart-reservation-end';
    const duration = 10 * 60 * 1000;
    let end = parseInt(sessionStorage.getItem(key), 10);
    if (!end || Number.isNaN(end) || end <= Date.now()) {
      end = Date.now() + duration;
      sessionStorage.setItem(key, String(end));
    }
    this.end = end;
    this.timeEl = this.querySelector('[data-timer-value]');
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = Math.max(0, this.end - Date.now());
    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    if (this.timeEl) {
      this.timeEl.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
    }
    if (remaining <= 0) {
      clearInterval(this.interval);
    }
  }
}

if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', CartReservationTimer);
}
